// removed by extract-text-webpack-plugin
module.exports = {"bp":"(min-width: 700px)","white":"#FFFFFF","outerWrapper":"src-templates----solutionsTemplate-module---outerWrapper---3Prya","overlay":"src-templates----solutionsTemplate-module---overlay---1o68n","content":"src-templates----solutionsTemplate-module---content---2Ch2a","wrapper":"src-templates----solutionsTemplate-module---wrapper---oWKMn","solutions":"src-templates----solutionsTemplate-module---solutions---_EcjH"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/solutionsTemplate.module.css
// module id = 642
// module chunks = 267780758595360